// extracted by mini-css-extract-plugin
module.exports = {"company-logo":"CompanyLogo_company-logo__1ic5A"};